import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Row, Col } from 'react-bootstrap';
import { StyledNavCard } from './NavCard';

const StyledNavCardContainer = styled(Row)`
    ${StyledNavCard} {
        margin-bottom: 12px;
    }

    flex-shrink: 0;
`;

const NavCardContainer = ({ children }) => (
    <StyledNavCardContainer>
        {children.map((x) => {
            const { key, props: { sm = 12, md = 6, lg = 4, xl = 3 } } = x;
            return (
                <Col key={key} sm={sm} md={md} lg={lg} xl={xl}>
                    {x}
                </Col>
            );
        })}
    </StyledNavCardContainer>
);

NavCardContainer.propTypes = {
    children: PropTypes.arrayOf(PropTypes.node).isRequired,
};

export default NavCardContainer;
